module.exports = __webpack_public_path__ + "img/bus-b.aa9664e8.png";